import { render, staticRenderFns } from "./Ana.vue?vue&type=template&id=554ef470&"
import script from "./Ana.vue?vue&type=script&lang=js&"
export * from "./Ana.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports